'use client';

import { useResumeBuilderStore } from '@/stores/resume-builder-store';
import { Input } from '@/components/ui/forms/input';
import { Label } from '@/components/ui/forms/label';

export default function ContactSection() {
  const { resume, updateContent } = useResumeBuilderStore();

  if (!resume) return null;

  const { contact } = resume.content;

  const handleChange = (field: 'email' | 'phone' | 'location', value: string) => {
    updateContent({
      contact: {
        ...contact,
        [field]: value,
      },
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={contact.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          placeholder="john.doe@example.com"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input
          id="phone"
          type="tel"
          value={contact.phone || ''}
          onChange={(e) => handleChange('phone', e.target.value)}
          placeholder="+1 (555) 123-4567"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="location">Location</Label>
        <Input
          id="location"
          value={contact.location || ''}
          onChange={(e) => handleChange('location', e.target.value)}
          placeholder="San Francisco, CA"
        />
        <p className="text-caption text-muted-foreground">
          City and state/country is usually sufficient.
        </p>
      </div>
    </div>
  );
}
